// Right rail panels on the Plan page — overdue, next action, unscheduled
import UnscheduleDropZone from '@/features/planning/components/shared/UnscheduleDropZone';
import { shouldShowNextActionPanel } from '@/features/tasks/utils/views/nextActionUtils';
import { resolveOnboardingHighlightPanelId } from '@/features/planning/components/shared/planOnboardingHighlight';
import PlanRailOverduePanel from '@/features/planning/components/shared/PlanRailOverduePanel';
import PlanRailNextActionPanel from '@/features/planning/components/shared/PlanRailNextActionPanel';
import PlanRailUnscheduledPanel from '@/features/planning/components/shared/PlanRailUnscheduledPanel';
import { PLAN_RAIL_FLEX } from '@/features/planning/pages/planPageConstants';

export default function PlanPageRail({
  overdueTasks,
  nextActions,
  unscheduledTasks,
  overdueRailSlice,
  nextActionRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  planMode,
  planRailTasks,
  plannedParentIds,
  waitingForParentIds,
  tasksMap = new Map(),
  onboardingHighlightTaskId = null,
  onboardingHighlightAddTask = false,
  onOnboardingAddTaskUsed,
}) {
  const projectStateProps = { plannedParentIds, waitingForParentIds };
  const showNextAction =
    shouldShowNextActionPanel(tasksMap) && (nextActions?.length ?? 0) > 0;
  const unscheduledListTasks =
    (planMode ? planRailTasks : unscheduledTasks) || [];
  const onboardingHighlightPanelId = resolveOnboardingHighlightPanelId(
    onboardingHighlightTaskId,
    {
      nextActionRailSlice: showNextAction ? nextActionRailSlice : [],
      unscheduledTasks: unscheduledListTasks,
    },
  );
  const nextActionHighlightId =
    onboardingHighlightPanelId === 'next-action'
      ? onboardingHighlightTaskId
      : null;
  const unscheduledHighlightId =
    onboardingHighlightPanelId === 'unscheduled'
      ? onboardingHighlightTaskId
      : null;

  return (
    <UnscheduleDropZone
      data-testid="plan-rail"
      sx={{
        flex: PLAN_RAIL_FLEX,
        overflowY: 'auto',
        display: { xs: 'none', md: 'block' },
      }}
    >
      <PlanRailOverduePanel
        overdueTasks={overdueTasks}
        overdueRailSlice={overdueRailSlice}
        selectedTaskIds={selectedTaskIds}
        railSelectionHandlers={railSelectionHandlers}
        focusOwnerId={focusOwnerId}
        projectStateProps={projectStateProps}
      />
      <PlanRailNextActionPanel
        showNextAction={showNextAction}
        nextActions={nextActions}
        nextActionRailSlice={nextActionRailSlice}
        selectedTaskIds={selectedTaskIds}
        railSelectionHandlers={railSelectionHandlers}
        focusOwnerId={focusOwnerId}
        nextActionHighlightId={nextActionHighlightId}
        projectStateProps={projectStateProps}
      />
      <PlanRailUnscheduledPanel
        planMode={planMode}
        unscheduledTasks={unscheduledTasks}
        planRailTasks={planRailTasks}
        unscheduledListTasks={unscheduledListTasks}
        selectedTaskIds={selectedTaskIds}
        railSelectionHandlers={railSelectionHandlers}
        focusOwnerId={focusOwnerId}
        unscheduledHighlightId={unscheduledHighlightId}
        onboardingHighlightAddTask={onboardingHighlightAddTask}
        onOnboardingAddTaskUsed={onOnboardingAddTaskUsed}
        projectStateProps={projectStateProps}
      />
    </UnscheduleDropZone>
  );
}
